/**
 * Type guard function check if one unknown is an error or not
 * @param e
 * @returns
 */
export function isError(e: unknown): e is Error {
  return e instanceof Error;
}
